/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Shared_Time_Ago_A_Few_SecondsInputs */

const en_admin_shared_time_ago_a_few_seconds = /** @type {(inputs: Admin_Shared_Time_Ago_A_Few_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a few seconds ago`)
};

const de_admin_shared_time_ago_a_few_seconds = /** @type {(inputs: Admin_Shared_Time_Ago_A_Few_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vor wenigen Sekunden`)
};

const es_admin_shared_time_ago_a_few_seconds = /** @type {(inputs: Admin_Shared_Time_Ago_A_Few_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hace unos segundos`)
};

const fr_admin_shared_time_ago_a_few_seconds = /** @type {(inputs: Admin_Shared_Time_Ago_A_Few_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`il y a quelques secondes`)
};

const nl_admin_shared_time_ago_a_few_seconds = /** @type {(inputs: Admin_Shared_Time_Ago_A_Few_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`een paar seconden geleden`)
};

const it_admin_shared_time_ago_a_few_seconds = /** @type {(inputs: Admin_Shared_Time_Ago_A_Few_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pochi secondi fa`)
};

const pt_br2_admin_shared_time_ago_a_few_seconds = /** @type {(inputs: Admin_Shared_Time_Ago_A_Few_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`há alguns segundos`)
};

const pl_admin_shared_time_ago_a_few_seconds = /** @type {(inputs: Admin_Shared_Time_Ago_A_Few_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kilka sekund temu`)
};

const hu_admin_shared_time_ago_a_few_seconds = /** @type {(inputs: Admin_Shared_Time_Ago_A_Few_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`néhány másodperce`)
};

const ro_admin_shared_time_ago_a_few_seconds = /** @type {(inputs: Admin_Shared_Time_Ago_A_Few_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`acum cateva secunde`)
};

/**
* | output |
* | --- |
* | "a few seconds ago" |
*
* @param {Admin_Shared_Time_Ago_A_Few_SecondsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_shared_time_ago_a_few_seconds = /** @type {((inputs?: Admin_Shared_Time_Ago_A_Few_SecondsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Shared_Time_Ago_A_Few_SecondsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_shared_time_ago_a_few_seconds(inputs)
	if (locale === "de") return de_admin_shared_time_ago_a_few_seconds(inputs)
	if (locale === "es") return es_admin_shared_time_ago_a_few_seconds(inputs)
	if (locale === "fr") return fr_admin_shared_time_ago_a_few_seconds(inputs)
	if (locale === "nl") return nl_admin_shared_time_ago_a_few_seconds(inputs)
	if (locale === "it") return it_admin_shared_time_ago_a_few_seconds(inputs)
	if (locale === "pt-BR") return pt_br2_admin_shared_time_ago_a_few_seconds(inputs)
	if (locale === "pl") return pl_admin_shared_time_ago_a_few_seconds(inputs)
	if (locale === "hu") return hu_admin_shared_time_ago_a_few_seconds(inputs)
	return ro_admin_shared_time_ago_a_few_seconds(inputs)
});
export { admin_shared_time_ago_a_few_seconds as "admin.shared.time_ago_a_few_seconds" }